import { axios } from '@/services/axios';

export const getTRSRegistrations = (registrarID) => {
    const endpoint = `/TRSRegistrations/${registrarID}`;
    return axios.get(endpoint);
};
